module.exports = __webpack_public_path__ + "Server-CalamariNeedsUpgrade.TentacleActive.bb7085e57a47545b0bc328c57af53090.hashedasset.svg";